import { FC, memo } from "react";
import { IconProps } from "./types";
import { getPreparedSvgProps } from "./utils";
import { Svg } from "baseui/icon/styled-components";

const TelegramIcon: FC<IconProps> = ({ title, ...props }) => {
  const svgProps = getPreparedSvgProps(props);

  return (
    <Svg {...props} {...svgProps} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2C8.26967 2 2 8.26733 2 16C2 23.7315 8.26967 30 16 30C23.7315 30 30 23.7315 30 16C30 8.26733 23.7315 2 16 2ZM19.7613 22.8495C19.9807 23.0047 20.263 23.0432 20.515 22.9487C20.7658 22.853 20.9513 22.6372 21.0073 22.3758C21.5988 19.5968 23.0338 12.5618 23.5717 10.0348C23.6125 9.8435 23.5448 9.64517 23.3955 9.518C23.245 9.39083 23.0373 9.35467 22.853 9.42233C19.9993 10.4793 11.2108 13.7763 7.61867 15.1052C7.39117 15.1903 7.243 15.4085 7.25 15.65C7.25817 15.8903 7.42033 16.0992 7.65367 16.1692C9.26483 16.651 11.3788 17.3218 11.3788 17.3218C11.3788 17.3218 12.367 20.3062 12.8815 21.8228C12.9468 22.0142 13.0962 22.1635 13.2922 22.2148C13.4893 22.2662 13.6982 22.2125 13.8452 22.0737C14.6723 21.2932 15.951 20.0857 15.951 20.0857C15.951 20.0857 18.3823 21.8672 19.7613 22.8495ZM12.2678 16.9438L13.4112 20.7133L13.6655 18.3263C13.6655 18.3263 18.079 14.3445 20.5967 12.0753C20.6702 12.0088 20.6795 11.8968 20.6188 11.8187C20.5582 11.7405 20.4462 11.7218 20.3633 11.7755C17.4467 13.6375 12.2678 16.9438 12.2678 16.9438Z"
      />
    </Svg>
  );
};

export default memo(TelegramIcon);
